import moment from 'moment';
import PolicyDetailsModel from './PolicyDetailsModel';

export default class PolicyChangeRequestModel {
    constructor({
        sender, currentTime, messageType, senderEmail, subject, recipient, policyDetails
    }) {
        let currentTimeCST = false;
        try {
            if (currentTime) {
                currentTimeCST = currentTime.toLocaleString('en-US', { timeZone: 'America/Chicago' });
            }
            this.currentTime = currentTimeCST || new Date().toLocaleString('en-US', { timeZone: 'America/Chicago' });
        } catch (e) {
            this.currentTime = (currentTime || new Date()).toLocaleString('en-US');
        }
        this.sender = sender || 'iswebportaldev@w-insurance.com';
        this.messageType = messageType || 'policy-change-request-usa-change-summary';
        this.senderEmail = senderEmail || 'iswebportaldev@w-insurance.com';
        this.subject = subject || `Account Management - Policy Change Request : ${moment(this.currentTime).format('MM/DD/YYYY hh:mm A')}`;
        this.recipient = recipient || 'qagtestnotifications@w-insurance.com';
        this.policyDetails = policyDetails;
    }

    static toObjectModel(obj) {
        const model = Object.setPrototypeOf(obj, PolicyChangeRequestModel.prototype);
        model.policyDetails = Object.setPrototypeOf(
            obj.policyDetails,
            PolicyDetailsModel.prototype
        );
        return model;
    }
}
